import * as React from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
function SvgIconCustomChevronLeft({
  title,
  titleId,
  ...props
}: React.SVGProps<SVGSVGElement> & SVGRProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M14.5 19a.517.517 0 00.354-.14.457.457 0 000-.67L6.207 10l8.647-8.192a.457.457 0 000-.67.52.52 0 00-.707 0l-9 8.527a.457.457 0 000 .67l9 8.527A.513.513 0 0014.5 19H14.5z"
        fill="currentColor"
        fillRule="nonzero"
        stroke="currentColor"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export default SvgIconCustomChevronLeft;
